import React from 'react';
import css from './Slider_team.css';
// import ReactDOM from 'react-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// import EmailIcon from '../../assets/icons/passion_petrol.png';

// =========================
// Slide
// =========================

class Slide extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleSlideClick = this.handleSlideClick.bind(this);
    this.imageLoaded = this.imageLoaded.bind(this);
    this.slide = React.createRef();
  }

  handleMouseMove(event) {
    // const el = this.slide.current;
    // const r = el.getBoundingClientRect();
    // el.style.setProperty('--x', event.clientX - (r.left + Math.floor(r.width / 2)));
    // el.style.setProperty('--y', event.clientY - (r.top + Math.floor(r.height / 2)));
  }

  handleMouseLeave(event) {
    this.slide.current.style.setProperty('--x', 0);
    this.slide.current.style.setProperty('--y', 0);
  }

  handleSlideClick(event) {
    this.props.handleSlideClick(this.props.slide.index);
  }

  imageLoaded(event) {
    event.target.style.opacity = 1;
  }

  render() {
    const { src, name, subHeadline, index } = this.props.slide;

    const current = this.props.current;
    let classNames = css.slide;

    // if (current === index) classNames += `${css.slide}${css.slide__current}`;

    var isMobile = false; //initiate as false
    // device detection
    if(typeof window!=="undefined"){
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      isMobile = true;
    }
  }
    if (isMobile === false) {
      if (current === index) classNames = `${css.slide} ${css.slide__current}`;
      if (current + 1 === index) classNames = `${css.slide} ${css.slide__current}`;
      if (current + 2 === index) classNames = `${css.slide} ${css.slide__current}`;
      else if (current - 1 === index) classNames += `${css.slide} ${css.slide__previous}`;
      else if (current + 3 === index) classNames += `${css.slide} ${css.slide__next}`;
    } else {
      if (current === index) classNames = `${css.slide} ${css.slide__current}`;
      else if (current - 1 === index) classNames += `${css.slide} ${css.slide__previous}`;
      else if (current + 1 === index) classNames += `${css.slide} ${css.slide__next}`;
    }

    return (
      <li
        ref={this.slide}
        className={classNames}
        onClick={this.handleSlideClick}
        onMouseMove={this.handleMouseMove}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={css.slide__image__wrapper}>
          <img className={css.slide__image} alt={name} src={src} onLoad={this.imageLoaded} />
          <div className={css.gradient}></div>
          <article className={css.slide__content}>
            <h2 className={css.slide__headline}>{name}</h2>

            <h3 className={css.slide__subHeadline}>{subHeadline}</h3>

            {/* <p className={css.slide__email}>
              <div className={css.iconWrapper}>
                <img src={EmailIcon} width="35px" style={{ marginRight: '10px' }}></img>
              </div>
              {email}
            </p> */}
          </article>
        </div>
      </li>
    );
  }
}

// =========================
// Slider control
// =========================

// const SliderControl = ({ type, title, handleClick }) => {
//   return (
//     // <button className={`btn btn--${type}`} title={title} onClick={handleClick}>
//     <button className={`${css.btn} btn--${type}`} title={title} onClick={handleClick}>
//       {/* <svg className="icon" viewBox="0 0 24 24">
//         <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
//       </svg> */}

//       <ExpandMoreIcon className={css.arrows} style={{ fill: '#eb7472' }} />
//     </button>
//   );
// };

// =========================
// Slider
// =========================

class Slider_Team extends React.Component {
  constructor(props) {
    super(props);

    this.state = { current: 0 };
    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handleSlideClick = this.handleSlideClick.bind(this);
    this.setState = this.setState.bind(this);
  }

  handlePreviousClick() {
    const previous = this.state.current - 1;

    this.setState({
      current: previous < 0 ? this.props.slides.length - 1 : previous,
    });
  }

  handleNextClick() {
    const next = this.state.current + 1;

    this.setState({
      current: next === this.props.slides.length ? 0 : next,
    });
  }

  handleSlideClick(index) {
    if (this.state.current !== index) {
      this.setState({
        current: index,
      });
    }
  }

  render() {
    const { current } = this.state;
    const { slides, heading } = this.props;
    const headingId = `slider-heading__${heading.replace(/\s+/g, '-').toLowerCase()}`;
    const wrapperTransform = {
      transform: `translateX(-${current * (100 / slides.length)}%)`,
    };

    return (
      <div className={css.slider} aria-labelledby={headingId}>
        <ul className={css.slider__wrapper} style={wrapperTransform}>
          {/* <h3 id={headingId} class="visuallyhidden">
            {heading}
          </h3> */}

          {slides.map(slide => {
            return (
              <Slide
                key={slide.index}
                slide={slide}
                current={current}
                handleSlideClick={this.handleSlideClick}
              />
            );
          })}
        </ul>

        <div className={css.slider__controls}>
          <button className={css.btn} onClick={this.handlePreviousClick}>
            <ExpandMoreIcon
              className={css.arrows}
              style={{ fill: '#eb7472', transform: 'translateX( 45%) rotate(90deg)' }}
            />
          </button>

          <button className={css.btn} onClick={this.handleNextClick}>
            <ExpandMoreIcon
              className={css.arrows}
              style={{ fill: '#eb7472', transform: 'translateX( 45%) rotate(270deg)' }}
            />
          </button>
        </div>
      </div>
    );
  }
}

export default Slider_Team;
